import { Grid, Box, Typography, Skeleton } from "@mui/material";

export const EditChecklistPageSkeleton = () => {

    return (
        <Box sx={{ padding: 4, backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
            <Typography variant="h4" sx={{ marginBottom: 4, color: '#333' }}>
                <Skeleton width="40%" />
            </Typography>
            <Grid container spacing={4}>
                <Grid item xs={12} md={4}>
                    <Box sx={{ padding: 2, backgroundColor: '#fff', borderRadius: 2, boxShadow: 1 }}>
                        <Skeleton variant="rectangular" width="100%" height={200} />
                    </Box>
                </Grid>
                <Grid item xs={12} md={8}>
                    <Box sx={{ padding: 2, backgroundColor: '#fff', borderRadius: 2, boxShadow: 1 }}>
                        <Skeleton variant="rectangular" width="100%" height={400} />
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};